import { all } from 'redux-saga/effects';
import customerSaga from './sagas/customerSaga';
import batchSaga from './sagas/batchSaga';
import userSaga from './sagas/userSaga';
import taskSaga from './sagas/taskSaga';
import groupSagas from './sagas/groupSaga';
import { batchGroup } from './sagas/bacthGroupSaga';
import authSaga from './sagas/authSaga';
import configSaga from './sagas/configSaga';
import knowledgeBaseSaga from './sagas/knowledgeBaseSaga';
import settingsSaga from './sagas/settingsSaga';
import projectSaga from './sagas/projectSaga';
import departmentSaga from './sagas/departmentSaga';
import physicianSaga from './sagas/physicianSaga';
import stateSaga from './sagas/stateSaga';
import payerSaga from './sagas/payerSaga';
import ruleSaga from './sagas/ruleSaga';
import patientSaga from './sagas/patientSaga';
import insuranceSaga from './sagas/insuranceSaga';
import visitSaga from './sagas/visitSaga';
import encounterSaga from './sagas/encounterSaga';
import diagnosisSaga from './sagas/diagnosisSaga';
import serviceReducer from './reducers/serviceReducer';
import serviceSaga from './sagas/serviceSaga';
import icdSaga from './sagas/icdSaga';
import cptSaga from './sagas/cptSaga';
import hcpcSaga from './sagas/hcpcSaga';
import claimSaga from './sagas/claimSaga';
import agentsSaga from './sagas/agentSaga';
import promptSaga from './sagas/promptSaga';
import modelSaga from './sagas/modelSaga';
import testCaseSaga from './sagas/testCaseSaga';
import apikeySaga from './sagas/apikeySaga';
import { dasboardsaga } from './sagas/dashboardSaga';
import processorSaga from './sagas/processorSaga';
import organizationSaga from './sagas/organizationSaga';
import switchOrganizationSaga from './sagas/switchorganizationSaga';

function* rootSaga() {
  yield all([
    authSaga(),  
    customerSaga(),
    batchSaga(),
    userSaga(),
    taskSaga(),
    groupSagas(),
    batchGroup(),
    settingsSaga(),
    configSaga(),
    knowledgeBaseSaga(),
    projectSaga(),
    departmentSaga(),
    physicianSaga(),
    stateSaga(),
    payerSaga(),
    ruleSaga(),
    patientSaga(),
    insuranceSaga(),
    visitSaga(),
    encounterSaga(),
    diagnosisSaga(),
    serviceSaga(),
    icdSaga(),
    cptSaga(),
    hcpcSaga(),
    claimSaga(),
    agentsSaga(),
    promptSaga(),
    modelSaga(),
    testCaseSaga(),
    apikeySaga(),
    dasboardsaga(),
    processorSaga(),
    organizationSaga(),
    switchOrganizationSaga(),
  ]);
}

export default rootSaga;
